import React, { useEffect } from 'react';
import Carousel from 'react-multi-carousel';
import { Link } from 'react-router-dom';
import 'react-multi-carousel/lib/styles.css';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { get_banners } from '../store/reducers/homeReducer';

const BannerArrow = ({ onClick, direction }) => {
  const isLeft = direction === 'left';
  return (
    <button
      onClick={onClick}
      aria-label={isLeft ? 'Previous slide' : 'Next slide'}
      className={`
        absolute top-1/2 -translate-y-1/2 z-10
        ${isLeft ? 'left-4 sm:left-2' : 'right-4 sm:right-2'}
        w-11 h-11 sm:w-8 sm:h-8 rounded-full
        bg-white/20 hover:bg-white/55
        border border-white/35 hover:border-white/70
        backdrop-blur-sm
        flex items-center justify-center
        text-white
        shadow-[0_4px_16px_rgba(0,0,0,0.3)]
        transition-all duration-200 hover:scale-110
      `}
    >
      {isLeft
        ? <IoIosArrowBack className="text-[20px] drop-shadow-sm" />
        : <IoIosArrowForward className="text-[20px] drop-shadow-sm" />
      }
    </button>
  );
};

const Banner = () => {
  const dispatch = useDispatch();
  const { banners } = useSelector((state) => state.home);

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 1 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  useEffect(() => {
    dispatch(get_banners());
  }, [dispatch]);

  return (
    <div className="w-full overflow-hidden">
      <div className="w-full">
        <Carousel
          autoPlay
          infinite
          showDots
          responsive={responsive}
          arrows
          customLeftArrow={<BannerArrow direction="left" />}
          customRightArrow={<BannerArrow direction="right" />}
        >
          {banners.length > 0 &&
            banners.map((b, i) => (
              <Link key={i} to={`/product/details/${b.link}`}>
                <img
                  src={b.banner}
                  alt=""
                  className="w-full h-auto min-h-[140px] max-h-[450px] object-cover"
                />
              </Link>
            ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Banner;
